import Marquee from "react-fast-marquee";
import { MARQUEE_STATS } from "../../data/whitespaces";

export const StatsMarquee = () => {
  return (
    <section
      data-testid="stats-marquee"
      className="relative border-y border-white/10 bg-black/20 py-10 backdrop-blur-sm md:py-14"
    >
      <Marquee speed={45} gradient gradientColor="#0a0a0a" gradientWidth={120} autoFill>
        {MARQUEE_STATS.map((stat, i) => (
          <div key={i} className="flex items-center">
            <span
              className={`px-8 font-display text-4xl font-light uppercase tracking-tight md:px-14 md:text-6xl lg:text-7xl ${
                i % 3 === 1 ? "text-stroke-ember" : "text-stroke"
              }`}
            >
              {stat}
            </span>
            <span
              className={`h-2 w-2 rounded-full ${i % 3 === 1 ? "bg-ember" : "bg-teal"}`}
              style={{
                boxShadow:
                  i % 3 === 1
                    ? "0 0 12px rgba(245,165,36,0.9)"
                    : "0 0 12px rgba(0,240,255,0.9)",
              }}
            />
          </div>
        ))}
      </Marquee>
    </section>
  );
};

export default StatsMarquee;
